import { BaseProvider } from 'src/app/core/services/base-provider';
import * as i0 from "@angular/core";
import * as i1 from "../../../core/services/globals.service";
import * as i2 from "@angular/common/http";
export class TransactionRequirementServiceService extends BaseProvider {
    constructor(globals, http) {
        super();
        this.globals = globals;
        this.http = http;
        this.baseUrl = "userProcessRequirementService";
    }
    getByParams(params) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl +
                this.baseUrl +
                '/requirement' +
                `?requirementId=${params.requirementId}` +
                `&ProcessId=${params.processId}`;
            this.http
                .get(this.url)
                .subscribe((data) => {
                this.requirementData = data;
                resolve(data);
            }, err => { reject(err); });
        });
    }
    get(requirementId) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl +
                this.baseUrl + `?requirementId=${requirementId}`;
            this.http
                .get(this.url)
                .subscribe((data) => {
                // this.requirementData = data;
                resolve(data);
            }, err => { reject(err); });
        });
    }
    execute(requirementId) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl +
                this.baseUrl + `/${requirementId}`;
            this.http
                .post(this.url, null)
                .subscribe((data) => {
                resolve(data);
            }, err => { reject(err); });
        });
    }
    uploadRequirementFile(params) {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl + '/file';
            this.http
                .post(this.url, params)
                .subscribe((data) => {
                resolve(data.Data);
            }, err => { reject(err); });
        });
    }
}
TransactionRequirementServiceService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function TransactionRequirementServiceService_Factory() { return new TransactionRequirementServiceService(i0.ɵɵinject(i1.GlobalsService), i0.ɵɵinject(i2.HttpClient)); }, token: TransactionRequirementServiceService, providedIn: "root" });
